import React, { useEffect, useState } from "react";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { ArrowDownFromLine, Download, File, Heart } from "lucide-react";
import { connect, useSelector, useDispatch } from "react-redux";
import { toastr } from "react-redux-toastr";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { bindActionCreators } from "redux";

import { logout } from "../../../actions/baseActions";
import { setObj } from "../../../actions/noteActions";
import mathIntruments from "../../../assets/imgs/lesson-plan-math-instruments.png";
import Breadcrumb from "../../../components/Breadcrumb";
import ContentLessonPlans from "../../../components/LessonPlans";
import Loading from "../../../components/Loading";
import ProtectedRoute from "../../../components/ProtectedRoute";
import URL from "../../../config/api";
import axios from "../../../config/axios";

const mockLesson = {
  id: null,
  plan_lesson_title: "Explorando Adição no 1º ano do Ensino Fundamental",
  duration: 65,
  theme: "Adição",
  learning_objective: "Desenvolver o conceito de adição com números",
  bncc_codes: ["EF04MA06"],
  objective: "Desenvolver o conceito de adição com números",
  materials: ["Lápis", "Borracha", "Caderno", "Material de contagem"],
  description: "DESCRIÇÃO DO PLANO DE AULA",
  competences: [
    {
      number: 1,
      description: "lorem"
    },
    {
      number: 2,
      description: "lorem"
    },
    {
      number: 3,
      description: "lorem"
    }
  ],
  lessons: [
    {
      title: "Introdução",
      duration_minutes: 10,
      list_type: "order",
      topics: [
        {
          title: "Revisão de conteúdos anteriores",
          subtopics: [
            {
              paragraph: `O professor deve iniciar a aula relembrando brevemente os conceitos de números e contagem, que foram abordados em aulas anteriores. Isso pode ser feito através de uma rápida revisão oral, onde os estudantes são incentivados a participar, respondendo perguntas e contando em voz alta. O professor pode, por exemplo, perguntar: "Quem pode me dizer quantos dedos temos em uma mão?" ou "Quem pode contar até 10 para mim?".`
            }
          ]
        },
        {
          title: "Situações-problema",
          subtopics: [
            {
              paragraph: `Em seguida, o professor deve apresentar duas situações-problema que servirão de base para o Desenvolvimento da aula. A primeira pode ser: "Imaginem que temos 3 maçãs e 2 peras. Quantas frutas temos no total?". A segunda pode ser: "Se temos 5 brinquedos em uma caixa e adicionamos mais 3, quantos brinquedos temos agora?".`
            }
          ]
        },
        {
          title: "Contextualização",
          subtopics: [
            {
              paragraph: `O professor deve explicar que a adição é uma ferramenta que usamos o tempo todo em nossas vidas, seja para contar o número de doces em uma sacola, somar as idades de nossos amigos ou calcular o troco no caixa da loja. Ele deve enfatizar que a matemática não é apenas uma disciplina da escola, mas uma parte importante do nosso dia a dia.`
            }
          ]
        },
        {
          title: "Ganhar a atenção dos estudantes",
          subtopics: [
            {
              paragraph: `Para despertar o interesse dos estudantes, o professor pode compartilhar algumas curiosidades sobre a adição. Por exemplo, ele pode mencionar que a adição é uma das operações matemáticas mais antigas, usada desde os tempos pré-históricos, quando as pessoas usavam os dedos para contar. Outra curiosidade é que a adição é uma operação comutativa, ou seja, a ordem dos números não altera o resultado: 2 + 3 é igual a 3 + 2.`
            }
          ]
        },
        {
          title: "Introdução do tópico",
          subtopics: [
            {
              paragraph: `Por fim, o professor deve introduzir o tópico da aula - "Explorando Adição" - e explicar que eles vão aprender mais sobre a adição e como usá-la para resolver problemas. Ele pode dizer: "Hoje vamos nos tornar exploradores da matemática e descobrir como a adição pode nos ajudar em várias situações!".`
            }
          ]
        }
      ]
    },
    {
      title: "Desenvolvimento",
      duration_minutes: 25,
      list_type: "order",
      footnote: `Essas atividades lúdicas e contextualizadas permitirão que os estudantes explorem o conceito de adição de maneira divertida e significativa, ao mesmo tempo em que desenvolvem suas habilidades de contagem e resolução de problemas. O professor deve estar atento para orientar os estudantes durante as atividades, esclarecendo dúvidas e reforçando os conceitos aprendidos.`,
      topics: [
        {
          title: `"Caça aos Números"`,
          // duration_minutes: 10,
          tags: ["Jogo", "Atividade em grupo"],
          subtopics: [
            {
              title: "Preparação",
              paragraph: `O professor deve preparar previamente cartões com números de 1 a 20, distribuindo-os aleatoriamente pelo ambiente da sala de aula. Além disso, será necessário ter uma cesta ou caixa grande para que os estudantes possam colocar os cartões que encontrarem.`
            },
            {
              title: "Descrição da atividade",
              paragraph: `O professor deve dividir a turma em grupos de 4 a 5 estudantes. Cada grupo receberá uma folha de papel e um lápis. O professor então dará o sinal para que os estudantes comecem a procurar os cartões. Quando um estudante encontrar um cartão, ele deve lê-lo em voz alta para o grupo, que então deverá somar aquele número ao total já encontrado. O grupo deve escrever a soma na folha de papel. O jogo continua até que todos os cartões tenham sido encontrados. O grupo que tiver a maior soma no final será o vencedor.`
            },
            {
              title: "Desenvolvimento da atividade",
              paragraph: `O professor deve explicar claramente as regras do jogo e garantir que todos os estudantes compreendam. Ele deve circular pela sala, observando o progresso dos grupos e ajudando aqueles que encontrarem dificuldades. Ao final da atividade, o professor deve reunir os estudantes e discutir as somas encontradas por cada grupo, reforçando o conceito de adição e a ideia de que a ordem dos números não altera o resultado.`
            }
          ]
        },
        {
          title: `"Loja de Brinquedos"`,
          // duration_minutes: 10,
          tags: ["Jogo", "Atividade em grupo"],
          subtopics: [
            {
              title: "Preparação",
              paragraph: `O professor deve preparar previamente cartões com imagens de brinquedos e preços (de 1 a 20) escritos neles. Além disso, será necessário ter uma caixa ou saco grande para que os cartões possam ser colocados.`
            },
            {
              title: "Descrição da atividade",
              paragraph: `O professor deve dividir a turma em grupos de 4 a 5 estudantes. Cada grupo receberá uma folha de papel e um lápis. O professor então explicará que eles estão em uma loja de brinquedos e que cada grupo tem uma quantia de dinheiro para gastar. O professor, então, dará o sinal para que os estudantes escolham os brinquedos que desejam comprar, anotando o preço de cada um. Quando todos os brinquedos tiverem sido escolhidos, os estudantes devem somar os preços e verificar se têm dinheiro suficiente. Se não tiverem, devem retirar um ou mais brinquedos. O jogo continua até que todos os grupos tenham gasto todo o seu dinheiro. O grupo que tiver sobrado mais dinheiro será o vencedor.`
            },
            {
              title: "Desenvolvimento da atividade",
              paragraph: `O professor deve explicar claramente as regras do jogo e garantir que todos os estudantes compreendam. Ele deve circular pela sala, observando o progresso dos grupos e ajudando aqueles que encontrarem dificuldades. Ao final da atividade, o professor deve reunir os estudantes e discutir as compras feitas por cada grupo, reforçando o conceito de adição e a ideia de que a ordem dos números não altera o resultado.`
            }
          ]
        },
        {
          title: `"História das Frutas"`,
          // duration_minutes: 10,
          tags: ["Jogo", "Atividade em grupo"],
          subtopics: [
            {
              title: "Preparação",
              paragraph: `O professor deve preparar previamente cartões com imagens de diferentes frutas e quantidades (de 1 a 20) escritas neles. Além disso, será necessário ter uma caixa ou saco grande para que os cartões possam ser colocados.`
            },
            {
              title: "Descrição da atividade",
              paragraph: `O professor deve dividir a turma em grupos de 4 a 5 estudantes. Cada grupo receberá uma folha de papel e um lápis. O professor então explicará que eles estão em uma fazenda cheia de frutas e que devem contar a quantidade de cada fruta que encontrarem. Cada vez que encontrarem uma fruta, devem somar a quantidade ao total já encontrado. O jogo continua até que todos os grupos tenham contado todas as frutas. O grupo que tiver a maior quantidade de frutas no final será o vencedor.`
            },
            {
              title: "Desenvolvimento da atividade",
              paragraph: `O professor deve explicar claramente as regras do jogo e garantir que todos os estudantes compreendam. Ele deve circular pela sala, observando o progresso dos grupos e ajudando aqueles que encontrarem dificuldades. Ao final da atividade, o professor deve reunir os estudantes e discutir as quantidades de frutas encontradas por cada grupo, reforçando o conceito de adição e a ideia de que a ordem dos números não altera o resultado.`
            }
          ]
        }
      ]
    },
    {
      title: "Retorno",
      duration_minutes: 15,
      list_type: "order",
      footnote: `Essa etapa de Retorno é crucial para consolidar o aprendizado dos estudantes, permitindo que eles reflitam sobre o que aprenderam e como podem aplicar esse conhecimento em suas vidas. Além disso, ela fornece ao professor um feedback valioso sobre a eficácia da aula e as necessidades de aprendizado dos estudantes.`,
      topics: [
        {
          title: `Discussão em Grupo`,
          duration_minutes: 7,
          subtopics: [
            {
              title: "Compartilhamento das Soluções",
              paragraph: `O professor deve reunir todos os estudantes em um grande círculo e pedir que cada grupo compartilhe brevemente suas soluções ou conclusões das atividades realizadas. Cada grupo terá um máximo de 3 minutos para falar. Durante essa apresentação, os estudantes devem ser incentivados a explicar como chegaram a suas respostas, quais estratégias usaram e quais desafios enfrentaram.`
            },
            {
              title: "Conexão com a Teoria",
              paragraph: `Após cada apresentação, o professor deve fazer perguntas para ajudar os estudantes a conectar a atividade prática com a teoria aprendida. Por exemplo, "Como vocês usaram a adição para resolver o problema da loja de brinquedos?" ou "Como vocês aplicaram a adição na atividade da história das frutas?". O objetivo é reforçar o conceito de adição e mostrar aos estudantes como eles aplicaram esse conceito em situações práticas.`
            }
          ]
        },
        {
          title: `Reflexão Individual`,
          duration_minutes: 5,
          subtopics: [
            {
              title: "Momento de Reflexão",
              paragraph: `Após as apresentações, o professor deve propor um momento de reflexão individual. Ele pode fazer perguntas como: "Qual foi a parte mais divertida da aula de hoje?" ou "O que você aprendeu sobre adição que não sabia antes?". Os estudantes terão um minuto para pensar em suas respostas.`
            },
            {
              title: "Compartilhamento das Reflexões",
              paragraph: `Após o minuto de reflexão, o professor deve pedir que alguns estudantes compartilhem suas respostas com a turma. Isso permitirá que os estudantes aprendam uns com os outros e que o professor tenha uma ideia de como os estudantes internalizaram os conceitos aprendidos.`
            }
          ]
        },
        {
          title: `Verificação do Aprendizado`,
          duration_minutes: 3,
          subtopics: [
            {
              title: "Perguntas de Verificação",
              paragraph: `Para verificar o aprendizado dos estudantes, o professor deve fazer duas ou três perguntas relacionadas ao tema da aula. Por exemplo, "Se temos 4 maçãs e 3 peras, quantas frutas temos no total?" ou "Se temos 10 lápis e adicionamos mais 5, quantos lápis temos agora?". Os estudantes devem responder oralmente, e o professor deve corrigir e explicar as respostas, se necessário.`
            },
            {
              title: "Feedback do Professor",
              paragraph: `Por fim, o professor deve fornecer um feedback geral sobre a aula, destacando os pontos positivos e as áreas que precisam de mais prática ou revisão. Ele pode dizer, por exemplo: "Estou muito feliz com o progresso de todos. Vocês fizeram um ótimo trabalho somando as frutas e os brinquedos. Lembrem-se sempre de que a ordem dos números não altera o resultado. Continuem praticando, e em breve vocês serão especialistas em adição!".`
            }
          ]
        }
      ]
    }
  ],
  evaluation: ["Prova Escrita"],
  notes: "É importante incentivar a participação de todos os estudantes.",
  references: [
    {
      titulo: "Funções: introdução",
      tipo: "Aula",
      link: "https://ava.educandus.com.br/content/view/29617"
    },
    {
      titulo: "Função inversa",
      tipo: "Aula",
      link: "https://ava.educandus.com.br/content/view/29624"
    },
    {
      titulo: "Função exponencial",
      tipo: "Aula",
      link: "https://ava.educandus.com.br/content/view/29704"
    },
    {
      titulo: "Função modular",
      tipo: "Aula",
      link: "https://ava.educandus.com.br/content/view/29800"
    },
    {
      titulo: "Logaritmos",
      tipo: "Aula",
      link: "https://ava.educandus.com.br/content/view/29951"
    }
  ],
  discipline_id: 3,
  discipline_name: "Matemática",
  segment_id: 2,
  segment_name: "Ensino Fundamental Anos Iniciais",
  serie_id: 7,
  serie_name: "1º Ano EF",
  depth_classification: "teste",
  deleted_at: null
};

const LessonPlan = ({ currentRoute }) => {
  const [loading, setLoading] = useState(true);
  const [plan, setPlan] = useState({});

  const user = useSelector(state => state.user);

  const pathname = useLocation().pathname.split("/");
  const lessonId = pathname[pathname.length - 1];

  useEffect(() => {
    axios
      .get(`${URL.api}lessonplans/${lessonId}`, {
        headers: { authorization: `Bearer ${user.token}` }
      })
      .then(lessonResponse => {
        // setLesson({
        //   ...lessonResponse.data.data,
        //   lessons: JSON.parse(lessonResponse.data.data.lessons)
        // });
        setPlan(mockLesson);
        setLoading(false);
      })
      .catch(() => {
        toastr.error("Não foi possível encontrar esse plano de aula.");
      });
  }, []);

  const exportToPDF = async () => {
    const element = document.getElementById("printable-lesson-plan");
    if (!element) {
      toastr.error("Erro ao imprimir plano de aula!");
      return;
    }

    const canvas = await html2canvas(element);
    const imgData = canvas.toDataURL("image/png");

    const imgWidth = 210;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    const pdf = new jsPDF("p", "mm", [imgWidth, imgHeight]);

    pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
    pdf.save("plano_de_aulas.pdf");
  };

  const themeColor = "danger";

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-5">
        <Breadcrumb current={currentRoute} />
        <div className="d-flex align-items-center">
          <button className="mr-2">
            <Heart size={16} />
          </button>
          <button onClick={exportToPDF}>
            <Download className="mr-1" size={16} />
          </button>
        </div>
      </div>
      {loading ? (
        <div className="p-4">
          <Loading />
        </div>
      ) : (
        <>
          <div
            className="d-flex flex-column container"
            id="printable-lesson-plan"
          >
            <div
              className={`mb-5 bg-${themeColor}`}
              style={{ position: "relative" }}
            >
              <div className="d-flex flex-column p-4 text-white">
                <h3 className="font-weight-bold mb-4">
                  {plan.plan_lesson_title}
                </h3>
                <h5 className="font-weight-normal mb-3">
                  <strong className="mr-1">Duração:</strong>
                  {plan.duration} minutos
                </h5>
                <h5 className="font-weight-normal mb-3">
                  <strong className="mr-1">Tema:</strong>
                  {plan.theme}
                </h5>
                <h5 className="font-weight-normal mb-3">
                  <strong className="mr-1">Habilidades BNCC:</strong>
                  {plan.bncc_codes.join("; ")}
                </h5>
                <h5 className="font-weight-normal mb-3" style={{ zIndex: "1" }}>
                  <strong className="mr-1">
                    Objetivo geral de aprendizagem:
                  </strong>
                  {plan.learning_objective}
                </h5>
                <h5 className="font-weight-normal mb-3">
                  <strong className="mr-1">Objetivo(s) do conhecimento:</strong>
                  {plan.objective}
                </h5>
                <h5 className="font-weight-normal mb-3">
                  <strong className="mr-1">Ano:</strong>
                  {plan.serie_name}
                </h5>
                <h5 className="font-weight-normal" style={{ zIndex: "1" }}>
                  <strong className="mr-1">Recursos necessários:</strong>
                  {plan.materials.join(", ")}
                </h5>
              </div>
              <div
                className="d-flex align-items-center"
                style={{
                  width: "264px",
                  position: "absolute",
                  right: "32px",
                  top: "0",
                  bottom: "0"
                }}
              >
                <img src={mathIntruments} alt="Instrumentos de Matemática" />
              </div>
            </div>

            <article>
              <section className="mb-5">
                <h4 className="mb-4 font-weight-bold">Descrição</h4>
                <p className="mb-5">{plan.description}</p>
                <h4 className="mb-4 font-weight-bold">
                  Competências desenvolvidas
                </h4>
                <div className="d-flex align-items-center flex-wrap">
                  {plan.competences.map((competence, index) => (
                    <div
                      key={index}
                      className={`d-flex align-items-center flex-1 bg-${
                        index % 2 === 0
                          ? `${themeColor}-translucent`
                          : themeColor
                      } p-3`}
                      style={{
                        minWidth: "50%"
                      }}
                    >
                      <strong
                        className="ml-3 mr-4"
                        style={{ fontSize: "42px" }}
                      >
                        {competence.number}
                      </strong>
                      <p className="m-0">{competence.description}</p>
                    </div>
                  ))}
                </div>
              </section>

              <section className="d-flex flex-column">
                <h4 className="mb-4 font-weight-bold">Atividades</h4>

                {plan.lessons.map((lesson, index) => (
                  <>
                    <h5 className="mb-3">
                      <strong>
                        {lesson.title} ({lesson.duration_minutes} minutos):
                      </strong>
                    </h5>
                    {lesson.list_type === "order" ? (
                      <ol className="mb-4">
                        <LessonPlanContent topics={lesson.topics} />
                      </ol>
                    ) : (
                      <ul className="mb-4">
                        <LessonPlanContent topics={lesson.topics} />
                      </ul>
                    )}
                    <p className="mb-4">{lesson?.footnote}</p>
                  </>
                ))}
              </section>
            </article>
          </div>
        </>
      )}
      {/* <ProtectedRoute routeId={currentRoute} /> */}
    </>
  );
};

const LessonPlanContent = ({ topics }) => (
  <>
    {topics?.map((topic, index) => (
      <li key={index} className="mb-3">
        <div className="d-flex align-items-center mb-2">
          <h5 className="mr-3 mb-0 font-weight-bold">
            {topic?.title}
            {topic?.duration_minutes && (
              <span className="ml-2 text-muted">
                ({topic?.duration_minutes} minutos)
              </span>
            )}
          </h5>
          {topic?.tags?.map((tag, index) => (
            <small key={index} className="py-1 px-2 rounded bg-secondary mr-2">
              {tag}
            </small>
          ))}
        </div>
        <ul>
          {topic.subtopics?.map((subtopic, index) => (
            <li key={index}>
              {subtopic.title && (
                <strong className="mr-1">{subtopic?.title}:</strong>
              )}
              {subtopic.paragraph}
            </li>
          ))}
        </ul>
      </li>
    ))}
  </>
);

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(LessonPlan);
